export const ASSIGNMENT_ROUTES = {
  DETAILS: {
    NAME: "assignment-details",
    PATH: "/assignment/details/:assignmentId"
  },
  EXPLORE: {
    NAME: "assignment-explore",
    PATH: "/assignment/explore/"
  }
};
